<div class="container">
  <div class="bulletChart" [attr.id]="idData"></div>
</div>
